import React from "react";
import { Box, Grid, Typography, Paper, Avatar } from "@mui/material";
import { styled } from "@mui/material/styles";
import saraImage from "../assets/sara-2.jpg";

const Headline = styled(Typography)(({ theme }) => ({
    fontWeight: 400,
    fontSize: "clamp(2rem, 6vw, 3rem)",
    color: "rgba(28, 30, 46, 1)",
    marginBottom: theme.spacing(3),
    [theme.breakpoints.down("sm")]: {
        textAlign: "center",
        marginBottom: theme.spacing(2),
    },
}));

const BodyText = styled(Typography)(({ theme }) => ({
    fontWeight: 400,
    fontSize: "clamp(1rem, 4vw, 1.125rem)",
    color: "rgba(74, 74, 74, 1)",
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
        textAlign: "center",
    },
}));

const AuthorText = styled(Typography)(({ theme }) => ({
    fontWeight: 700,
    fontSize: "clamp(1rem, 4vw, 1.125rem)",
    color: "rgb(238, 186, 178)",
    [theme.breakpoints.down("sm")]: {
        textAlign: "center",
        display: "block",
        marginTop: theme.spacing(1),
    },
}));

const WhyThisBook = () => (
    <Box component="section" sx={{ background: "#fff" }}>
        <Paper
            elevation={0}
            sx={{
                mx: "auto",
                p: { xs: 2, md: 6 },
                background: "transparent",
            }}
        >
            <Typography variant="h3" sx={{ textAlign: "center", mb: 4, fontWeight: 600, fontSize: { xs: 24, md: 32 } }}>
                <strong>Why I Wrote This eBook…</strong>
            </Typography>
            <Grid container spacing={{ xs: 2, md: 4 }} alignItems="flex-start">
                <Grid item xs={12} md={6} lg={6}>
                    <Box
                        sx={{
                            width: 1,
                            display: "flex",
                            justifyContent: { xs: "center", md: "flex-start" },
                            mb: { xs: 2, md: 0 },
                        }}
                    >
                        <Avatar
                            src={saraImage}
                            alt="Sara Hafez"
                            variant="rounded"
                            sx={{
                                width: { xs: 220, sm: 300, md: 463, lg: 600 },
                                height: { xs: 220, sm: 300, md: 463, lg: 600 },
                                maxWidth: "100%",
                            }}
                        />
                    </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                    <BodyText>
                        <strong>Because I’ve been there,</strong> standing in the hallway wondering, <em>“Am I doing enough?”</em>
                    </BodyText>
                    <BodyText>
                        As both a <strong>mother</strong> and a <strong>Positive Psychology specialist</strong>, I’ve seen how easily we slip from connection into chaos, rushing through routines, reacting to emotions, and forgetting that <strong><em>parenting is meant to be joyful, not just exhausting.</em></strong>
                    </BodyText>
                    <BodyText>
                        I created <strong><em>Happy US</em></strong> to bring parents back home to themselves, to their children, and to the quiet magic in ordinary moments.
                    </BodyText>
                    <BodyText>
                        It’s where <strong>science meets soul</strong>: every activity, reflection, and conversation starter is rooted in <strong>Positive Psychology research</strong>, yet designed to feel warm, simple, and beautifully human.<br />
                        This isn’t just another parenting book.
                    </BodyText>
                    <BodyText>
                        It’s a <strong>gentle roadmap</strong> to help you raise <strong>resilient, kind, and hopeful children</strong> while rediscovering your own calm, confidence, and clarity along the way.
                    </BodyText>
                    <BodyText>
                        Because you already have everything it takes to nurture emotionally strong, grateful, and connected kids.
                    </BodyText>
                    <BodyText>
                        <strong>
                            This eBook simply helps you <em>see it, live it, and grow through it, one intentional moment at a time.</em>
                        </strong>
                    </BodyText>
                    <Box sx={{ mt: 2, textAlign: { xs: "center", md: "left" } }}>
                        <Typography variant="body1" sx={{ color: "rgba(0,0,0,1)",  fontSize: 18, display: "inline" }}>
                            —{" "}
                        </Typography>
                        <AuthorText component="span">
                            Sara Hafez, MSc in Positive Psychology (UK)
                        </AuthorText>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    </Box>
);

export default WhyThisBook;